'use client';

import type { ReactNode } from 'react';
import { useState } from 'react';
import Details from 'components/shared/BaseAccordion/Details';
import Summary from 'components/shared/BaseAccordion/Summary';

interface BentoBoxCardMobileAccordionProps {
  children: ReactNode;
  label: string;
  summary: ReactNode;
}

export const BentoBoxCardMobileAccordion = ({ children, label, summary }: BentoBoxCardMobileAccordionProps) => {
  const [open, setIsOpen] = useState(false);

  return (
    <Details open={open}>
      <Summary
        openIcon="add_circle"
        closeIcon="remove_circle"
        label={label}
        isActive={open}
        onClick={setIsOpen}
        data-testid="mobile-bento-card-summary">
        {summary}
      </Summary>
      {children}
    </Details>
  );
};
